<template>
  <div class="max-w-lg m-auto my-16">

    <BrokerpadLogo></BrokerpadLogo>

    <div class="p-8 bg-white mt-6 rounded shadow-lg border">

      <div class="text-2xl font-light text-gray-700">Un-authorized</div>

      <div class="mt-4 text-base text-gray-700">
        You have been logged out. 
        Please 

        <router-link :to="{ name : 'auth-login' }" tag="a" class="text-blue-500 hover:text-blue-600 underline">login again</router-link>.
      </div>      
    </div>

    <div class="pl-8 mt-6">
      <PublicFooter theme="dark"></PublicFooter>
    </div>
  </div>
</template>

<script>
  import PublicFooter   from "@/shared/components/public/Footer"
  import BrokerpadLogo  from '@/shared/components/BrokerpadLogo';

  export default {

    components : {
      BrokerpadLogo,
      PublicFooter
    },

    mounted() {
      document.body.className = 'bg-gray-100'
    },

    beforeDestroy() {
      document.body.className = ''
    },
  }
</script>